import DatePicker from './datePicker.vue';

DatePicker.install = (Vue) => {
  Vue.component(DatePicker.name, DatePicker);
};

export default DatePicker;
